import React from 'react';

export default () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 32"
  >
    <title>onboarding_swipe</title>
    <path
      id="swipe-up"
      d="M5.25,3.55v9.08H4.58V3.56L.69,7.62.25,7.16,4.92,2.28,9.59,7.16l-.45.46Z"
    />
    <path d="M6.28,20.54a3,3,0,0,1-.1-.32,4.45,4.45,0,0,0-.94-2c-1-1.13.54-1.43,1-1.23a5.74,5.74,0,0,1,1.91,2.16c.54,1,1.53,1.58,2.07,1.38s.93-.5.29-3.6-1.42-6.72-1.37-7c.2-1,1.52-.79,1.81,0s.43,1.52.64,2.27a20.08,20.08,0,0,0,1.16,4c1-.41,2,.51,2.58,1.28.12.16,1,.28,1.23.36a2.23,2.23,0,0,1,1.57,1.32,2.43,2.43,0,0,0,.35.49c.19.2.64.34.89.55a1.35,1.35,0,0,1,.39,1.07,23.08,23.08,0,0,1-.34,5c-.3.59.34,2.16.34,2.16l-7.28,1.24c.16,0-.23-1.64-.32-1.8-.3-.59-.74-.72-1.31-.94a4.58,4.58,0,0,1-2.6-2.73,12.64,12.64,0,0,0-1-2.2A10,10,0,0,1,6.28,20.54Z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/tour/assets/onboarding/SwipeSvg.js